/* Sticky CTA bar untuk landing page BOA.
   Bar-nya ditulis di dalam deskripsi produk sebagai <div class="boa-sticky">.
   Script ini hanya memunculkannya setelah pengunjung melewati area harga. */
(function () {
  function init() {
    var bar = document.querySelector('.boa-sticky');
    if (!bar) return;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var trigger = document.querySelector('.boa-lp');
    if (!trigger || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', entries[0].isIntersecting || entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(trigger);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
